import { render } from "./AlertsContent.vue?vue&type=template&id=083b2afe"
import script from "./AlertsContent.vue?vue&type=script&lang=js"
export * from "./AlertsContent.vue?vue&type=script&lang=js"

import "./AlertsContent.vue?vue&type=style&index=0&id=083b2afe&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__